import { render, staticRenderFns } from "./DlgSubscriptionsDelete.vue?vue&type=template&id=07f84312&scoped=true&"
import script from "./DlgSubscriptionsDelete.vue?vue&type=script&lang=ts&"
export * from "./DlgSubscriptionsDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f84312",
  null
  
)

export default component.exports